
export const setCurrentLottery = (state, data) => {
  state.currentLottery = data
}
